// src/components/layout/MainLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './MainLayout.css'; // ✅ Add this line to include the global CSS reset


function MainLayout() {
  return (
    <div
      style={{
        display: 'flex',
        margin: 0,
        padding: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden', // keep structure tight
      }}
    >
      <Sidebar />
      <div
        style={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          margin: 0,
          padding: 0,
          height: '100vh',
        }}
      >
        <Header />
        <main
          style={{
            flexGrow: 1,
            margin: 0,
            padding: 0,
            overflowY: 'auto', // ✅ allows vertical scrolling
            overflowX: 'hidden',
            background: '#fff', // or sunlight gradient if you prefer
          }}
        >
          <Outlet />
        </main>
        <footer
          style={{
            padding: '10px',
            textAlign: 'center',
            borderTop: '1px solid #ccc',
            margin: 0,
            background: '#000000',
            flexShrink: 0, // ✅ prevents footer from shrinking
          }}
        >
          Admin Panel © {new Date().getFullYear()}
        </footer>
      </div>
    </div>
  );
}

export default MainLayout;
